import React, {Component} from 'react'

const Jeyu = {
  box: {
    background: '#333',
    height: '100vh'
  }
}

export default class Removed extends Component {
  componentDidMount(){
    window.location = ('/UserProfile')
  }
  render() {
    return(
      <div style={Jeyu.box}></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/Removed.js